import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TranslateModule } from '@ngx-translate/core';
import { JtDatepickerComponent } from './jt-datepicker.component';
import { SvgIconModule } from '@customcomponent/Icons/_svg/app-jt-svg-icon.module';

@NgModule({
    declarations: [JtDatepickerComponent],
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        SvgIconModule,
        BsDatepickerModule.forRoot()
    ],
    exports: [JtDatepickerComponent]
})
export class JtDatepickerModule { }
